import { render, staticRenderFns } from "./AccountSubscriptionCancellation.vue?vue&type=template&id=985bca1c&scoped=true&"
import script from "./AccountSubscriptionCancellation.vue?vue&type=script&lang=js&"
export * from "./AccountSubscriptionCancellation.vue?vue&type=script&lang=js&"
import style0 from "./AccountSubscriptionCancellation.vue?vue&type=style&index=0&id=985bca1c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985bca1c",
  null
  
)

export default component.exports